import { Box } from "@mui/material";
import * as React from "react";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { IMessageListItem } from "source/models/message/messageListItem";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import * as messageService from "../../../models/services/messageService";
import { Dialog } from "../../framework/Dialog/Dialog";
import { MessageContentContainer } from "../MessageList/MessageList.styles";
import { MessageListAttachments } from "../MessageListAttachments";
import { MessageListHeader } from "../MessageListHeader/MessageListHeader";
import { ReadReceiptCategory } from "ui/Scripts/source/models/enums";

export interface IMessageReadReceiptDialogProp {
    item: IMessageListItem;
    onClose: (id: string) => void;
}

export class MessageReadReceiptDialog extends React.Component<IMessageReadReceiptDialogProp, {}> {
    componentDidMount(): void {
        const props = this.props;
        if (props.item.isRead) return;
        AppUtils.callService(() => messageService.sendReadReceipt(props.item.id, props.item.companyId, ReadReceiptCategory.Automatic));
    }

    handleClose = () => {
        const props = this.props;
        props.onClose(props.item.id);
    };

    handleSendReadReceipt = async () => {
        const props = this.props;
        //Call server
        const result = await AppUtils.callService(() => messageService.sendReadReceipt(props.item.id, props.item.companyId, ReadReceiptCategory.ManualRequest));
        if (!result) return;
        this.handleClose();
    };

    render() {
        const props = this.props;
        return (
            <Dialog
                id="messageReadReceiptDialog"
                maxWidth="xl"
                title={Translations.ReadReceiptMessage}
                body={
                    <>
                        <MessageListHeader
                            item={props.item}
                            canEditMessages={false}
                            editMode={false}
                            onForwardMessage={null}
                            onOpenMessage={null}
                        />
                        <MessageContentContainer dangerouslySetInnerHTML={{ __html: props.item.content }}></MessageContentContainer>
                        <MessageListAttachments
                            item={props.item}
                        />
                    </>
                }
                actions={
                    <Box display="flex" justifyContent="end" width="100%">
                        <DialogButtons
                            saveTitle={Translations.MarkMessageAsRead}
                            onCancel={this.handleClose}
                            onSave={this.handleSendReadReceipt}
                        />
                    </Box>
                }
                onClose={this.handleClose}
            />
        );
    }
}